/* eslint-disable import/no-anonymous-default-export */
import { AxiosError } from "axios";
import useApi, { ActionResult, Model } from "../../common/hooks/useApi"
import { List } from "lodash";

const module = "Dashboard";

export interface EstadisticasRequest {
    pagasImpagasYear: number,
    CapturasEquipoId: number,
    CapturasEquipoYear: number,
    CapturasEquipoMonth: number,
    FechaEquipoId: number,
    FechaEquipoYear: number
}

export interface EstadisticasPagasImpagas extends Model {
    anio: number,
    mes: number,
    pagadas: string,
    impagas: number,
    impresas: number
}

export interface EstadisticasEquipo extends Model {
    anio: number,
    mes: number,
    dia: number,
    totalCapturadas: string,
    totalProcesoVerificacion: number,
    totalIlegibles: number
}

export interface EstadisticasEquipoFecha extends Model {
    anio: number,
    mes: number,    
    cantidadTotal: number,
    cantidadPagadas: { nombre: string, cantidad: number, value: number }[]
}

export interface HomeResumenRequest {
    pageSize: number;
    pageNumber: number;
    fechaGeneradaDesde: string,
    fechaGeneradaHasta: string,
    estadoPago: string,
    municipio: number | null,
    tipoInfractor: string | null,
    tipoInfraccion: string | null
}

export type EstadisticaData = { pagasImpagasData?: EstadisticasPagasImpagas[], capturasEquipoData?: EstadisticasEquipo[], fechaPagasImpagasEquipoData?: EstadisticasEquipoFecha[] };
export type HomeDataHeader = { generadas: number, pagadas: number, porGenerar: number }
export type HomeDataResume = { 

    NumeroActa: string,
    EstadoPago: string,
    UnidadProduccion: string,
    FechaGenerada: string,
    FechaPago: string,
    MontoPago: string,
    TipoInfractor: string,
    EstadoVencimiento: string,
    TipoInfraccion: string
}
export type HomeData = {
    generadas: number, 
    generadasNuevas: number,
    regeneradas: number,
    pagadas: number,
    porGenerar: number,
    resumen: HomeDataResume,

    montoPagadas: number,
    pagasPVoluntario: number,
    montoPagasPVoluntario: number,
    pagasPTotal: number,
    montoPagasPTotal: number,
    impagas: number,
    montoImpagas: number,
    impagasPTotal: number,
    montoImpagasPTotal: number,
    impagasPVoluntario: number,
    montoImpagasPVoluntario: number,
    vencidas: number,
    montoVencidas: number,
    montoTotal: number,
    montoGeneradasNuevas: number,
    montoRegeneradas: number,
    porcentajePagasGeneradas: number,
    total: number
}

export default () => {
    const api = useApi({ module });

    return {
        getEstadisticas: async (request: EstadisticasRequest, identificador: number = 0): Promise<ActionResult<EstadisticaData>> => {
            try {                
                const data = { 
                    pagasImpagasYear: request.pagasImpagasYear,
                    CapturasEquipoId: request.CapturasEquipoId,
                    CapturasEquipoYear: request.CapturasEquipoYear,
                    CapturasEquipoMonth: request.CapturasEquipoMonth,
                    FechaEquipoId: request.FechaEquipoId,
                    FechaEquipoYear: request.FechaEquipoYear
                 }
                const response = await api.axiosInstance.post(`${module}`, data, {
                    headers: {                        
                        "Content-Type": "application/json"
                    },
                    params: { identificador }
                });                
                return {
                    data: { value: response.data }
                };
            } catch (error: any | AxiosError) {
                return { error };
            }
        },
        getHomeDataEncabezado: async (): Promise<ActionResult<HomeDataHeader>> => {
            try {                
                const data = { 
                   
                 }
                const response = await api.axiosInstance.get(`${module}/homeencabezado`)
                return {
                    data: { value: response.data }
                };
            } catch (error: any | AxiosError) {
                return { error };
            }
        },
        getHomeDataResumen: async (homeResumenRequest: HomeResumenRequest | undefined): Promise<ActionResult<HomeData>> => {
            try {
                const response = await api.axiosInstance.post(`${module}/homeresumen`, homeResumenRequest, {
                    headers: {                        
                        "Content-Type": "application/json"
                    },
                });                
                return {
                    data: { value: response.data }
                };
            } catch (error: any | AxiosError) {
                return { error };
            }
        },

    }
}